<div class="col-12 p-0">
  <div class="col-12 p-0">
    <div class="col-12 p-0 height100" *ngIf="selectedRace">
      <ng-container *ngIf="selectedClass &&
          selectedRace &&
          selectTable === appSettings.TABLE_TYPE.PROGRESS">
        <app-progress-list class="p-0 col-12 height100" [sections]="sections"
          [selectedRace]="selectedRace" [raceClasses]="raceClasses" [selectedLang]="appSettings.selectedLang"
          [selectedClass]="selectedClass" [TVResume]="TVResume" [timer]="timer"
          (refreshEvent)="changeSelectedRace($event)" (goToNewVersion)="goToNewVersion()"
          (openInfoEvent)="showModal($event)"></app-progress-list>
      </ng-container>
      <ng-container *ngIf="
          selectedClass &&
          selectedRace &&
          selectTable === appSettings.TABLE_TYPE.PROGRESSV2">
        <app-progress-list-v2 class="p-0 col-12 height100" [selectedRace]="selectedRace"
          [raceClasses]="raceClasses" [selectedLang]="appSettings.selectedLang" [selectedClass]="selectedClass"
          (refreshEvent)="changeSelectedRace($event)" (goToNewVersion)="goToOldVersion()"
          (openInfoEvent)="showModal($event)"
          (openCompetitorRaceDataEvent)="showCompetitorRaceDataModal($event)"></app-progress-list-v2>
      </ng-container>
      <ng-container *ngIf="
          selectedClass &&
          selectedRace &&
          (selectedRace.isOrg || authService.user?.admin) &&
          selectTable === appSettings.TABLE_TYPE.DOCUMENTS">
        <app-documents class="col-12 height100" [participants]="selectedClass.registrations" [selectedRace]="selectedRace"
          [raceClasses]="raceClasses" [selectedClass]="selectedClass"
          (refreshEvent)="changeSelectedRace($event)"></app-documents>
      </ng-container>
      <div *ngIf="selectTable === appSettings.TABLE_TYPE.DOCUMENTS && !selectedRace.isOrg && !authService.user?.admin" class="col-12 center">
        {{ appSettings.translate[appSettings.selectedLang]['accessdenied'] }}
      </div>
    </div>
  </div>
</div>

<!-- <p-confirmDialog #cd header="Подтвердите действие" icon="pi pi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-check" label="Да" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" label="Нет" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog> -->

<!-- Диалог с доп инфо об участнике -->
<p-dialog *ngIf="showCompetitorInfoModal"
  [header]="appSettings.translate[appSettings.selectedLang]['competitor_info_dialog']" [modal]="true" [draggable]="true"
  [(visible)]="showCompetitorInfoModal" [style]="{minWidth: '400px', maxWidth: '800px'}" [closable]="false">
  <div [innerHTML]="dataCompetitorInfoModal?.info"></div>
  <p-footer>
    <div class="ui-inputgroup document-buttons">
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['close']"
        (click)="showCompetitorInfoModal = false"></p-button>
    </div>
  </p-footer>
</p-dialog>

<!-- Диалог с доп инфо об времени участника -->
<p-dialog *ngIf="showCompetitorRaceInfoModal"
  [header]="appSettings.translate[appSettings.selectedLang]['competitor_info_dialog']" [modal]="true" [draggable]="true"
  [(visible)]="showCompetitorRaceInfoModal" [style]="{minWidth: '400px', maxWidth: '800px'}" [closable]="false">
  <div [innerHTML]="dataCompetitorRaceInfoModal"></div>
  <p-footer>
    <div class="ui-inputgroup document-buttons">
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['close']"
        (click)="showCompetitorRaceInfoModal = false"></p-button>
    </div>
  </p-footer>
</p-dialog>

<!-- Вывод изображений на полный экран -->
<div *ngIf="fullImageUrl" class="full-image-container">
  <img *ngIf="fullImageUrl" [src]="fullImageUrl" (click)="hideFullImage()" />
</div>

<!-- Вывод pdf на полный экран -->
<div *ngIf="fullPdfUrl" class="full-pdf-container" (click)="hideFullPdf()">
  <pdf-viewer [src]="fullPdfUrl" [render-text]="true" [original-size]="false" style="width: 100%; height: 100%">
  </pdf-viewer>
</div>